module.exports = __webpack_public_path__ + "img/0-filmin.743eca3d.svg";